var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-8"},[_c('form-input',{attrs:{"model":_vm.formModel,"attribute":"pattern","errors":_vm.formErrors,"placeholder":"Key cần xoá"}})],1),_c('div',{staticClass:"col-4"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.clear}},[_vm._v("Xoá")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }